<script setup>
import { computed } from 'vue';

import VirtualAssistant from '@/components/Layout/Components/TheVirtualAssistant.vue';
import { useInfoContent } from '@/composables/useInfoContent.js';
import { useVirtualAssistant } from '@/composables/useVirtualAssistant.js';
import { formStore } from '@/stores/form.js';

const { assistantExpertise } = useVirtualAssistant();

const props = defineProps({
  name: {
    type: String,
    required: false,
    default: null,
  },
  content: {
    type: String,
    required: false,
    default: null,
  },
});

const form = formStore();

const { infoPopup } = useInfoContent();

const popupContent = computed(() => {
  if (!props.content || !props.title) {
    const fetchedContent = infoPopup(props.name);
    return {
      title: props.title || fetchedContent.title,
      content: props.content || fetchedContent.content,
    };
  }
  return { title: props.title, content: props.content };
});

const titleBind = computed(() => popupContent.value.title);
const contentBind = computed(() => popupContent.value.content);
</script>

<template>
  <div
    v-if="titleBind !== null || contentBind !== null"
    class="layer2"
  >
    <BaseInfoButton
      :target="`${name}-canvas`"
      :aria-label="`${titleBind} info button`"
    />
    <BaseOffCanvas
      :target="`${name}-canvas`"
      :title="titleBind"
    >
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-html="contentBind" />
      <VirtualAssistant
        :expertise="assistantExpertise()"
        :name="form.specialist.name"
        :avatar="form.specialist.image_url"
      />
      <BaseButton
        type="button"
        data-bs-dismiss="offcanvas"
      >
        {{ $t('general.callToActionButton.continue') }}
      </BaseButton>
    </BaseOffCanvas>
  </div>
</template>
